import OnboardingRegistration from './OnboardingRegistration';

export default OnboardingRegistration;
